import { render, staticRenderFns } from "./CarePlanOverviewIcon.vue?vue&type=template&id=15652878"
import script from "./CarePlanOverviewIcon.vue?vue&type=script&lang=js"
export * from "./CarePlanOverviewIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports